import { Component } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from '../../core/services/common.service';
import { AuthService } from '../../core/services/auth.service';

interface Report {
  id: number;
  name: string;
  description: string;
  reportId: string;
  workspaceId: string;
  datasetId: string;
  sortOrder: number;
  isVisible: boolean;
}

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrl: './header.component.css',
    standalone: false
})
export class HeaderComponent {
  moduleName = 'Benchmarking Platform';
  email?: string;
  name?: string;
  isModalOpen = true;
  reports: Report[] = [];
  selectedReportId: number | null = null;

  constructor(
    public commonService: CommonService,
    public userService: AuthService,
    private modalService: NgbModal
  ) {
  }

  ngOnInit() {
    this.fetchReports();
    // Check local storage for a previously selected report
    //if (storedReport) {
    //  const parsedReport = JSON.parse(storedReport) as Report;
    //  this.selectedReportId = parsedReport.id;
    //}

  }

  logout() {
    this.userService.logoff();
  }

  closeRequestToEnhanceStudyModal() {
    this.isModalOpen = false;
  }

  fetchReports(): void {
    this.commonService.getReports().subscribe((data:any) => {
      this.reports = data;
    }) 
  }
  onReportSelect(reportId: number): void {
    this.selectedReportId = reportId;
    const selectedReport = this.reports.find(report => report.id === reportId);
    if (selectedReport) {
      // Store the selected report details in local storage
      this.commonService.$selectedReport?.next(selectedReport);      
      // Call inserUserReportSelection with the reportId
        this.commonService.inserUserReportSelection(reportId).subscribe(
            response => {
                // Handle successful response if needed
                this.commonService.$reloadReportOnSelection?.next(true);
                console.log('User report selection inserted successfully:', response);
            },
            error => {
                // Handle errors if needed
                console.error('Error inserting user report selection:', error);
            }
        );
    }
  }
  getSelectedReportName(): string {
    const selectedReport = this.commonService.$selectedReport?.getValue();

    if (selectedReport !== null) {
      return selectedReport.name;
    }
    return 'Please, Select a Report';
  }
}
